import React from 'react';
import { Card } from 'antd';
import WebIcon from 'mdi-react/WebIcon';
import './AcesseOSite.scss';

const AcesseOSite = (): JSX.Element => {
  return (
    <Card
      style={{ width: 150, height: 150 }}
      hoverable
      onClick={
        (): void => {
          window.open('http://www.coopercitrus.com.br/', '_blank');
        }
      }
      className="AcesseOSite"
    >
      <WebIcon size={80} className="AcesseOSite__icon" />
      <Card.Meta title="Acesse o site" className="AcesseOSite__title" />
    </Card>
  );
};

AcesseOSite.propTypes = {};
AcesseOSite.defaultProps = {};

export default AcesseOSite;
